import React from 'react'
import { useOutletContext } from 'react-router-dom'
import type { HistoryOutletContext } from './ModernHistoryLayout'

/** หน้า ประวัติเกมส์ BTD */
const HistoryBtdPage: React.FC = () => {
  useOutletContext<HistoryOutletContext>()

  return (
    <>
      <div className="c_quinary text-center">
        <h3 className="c_tertiary font_md">ประวัติเกมส์ BTD</h3>
      </div>
      <div className="border_5 bg_secondary py-5 overflow-hidden mt-3">
        <h4 className="text-center c_primary">ไม่มีรายการ</h4>
      </div>
    </>
  )
}

export default HistoryBtdPage
